// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Limpieza",
    laundry: "Lavandería",
    maintenance: "Mantenimiento y reparaciones",
    supplies: "Menaje y consumibles",
    utilities: "Suministros",
    staff: "Personal",
    software: "Software y herramientas",
    marketing: "Publicidad",
    taxes: "Impuestos y tasas",
    other: "Otros",
  },

  restricted: "Los egresos de la gestoría solo los ve la cuenta principal: tu acceso está limitado a algunos alojamientos.",

  summary: {
    aria: "Resumen de egresos del periodo. Pulsa una cifra para filtrar la tabla.",
    total: "Total egresos",
    count: "{n} egreso | {n} egresos",
    charged: "Repercutidos a propietarios",
    chargedHint: "Se descuentan en sus liquidaciones",
    own: "Propios de la gestión",
    ownHint: "Restan de tu beneficio",
  },

  toolbar: {
    search: "Buscar",
    searchPlaceholder: "Concepto o proveedor",
    clearSearch: "Borrar la búsqueda",
    category: "Categoría",
    allCategories: "Todas",
    listing: "Alojamiento",
    allListings: "Todos",
    type: "Tipo",
    allTypes: "Todos",
    charged: "Repercutidos al propietario",
    own: "Propios",
    create: "Nuevo egreso",
  },

  table: {
    date: "Fecha",
    category: "Categoría",
    concept: "Concepto",
    listing: "Alojamiento",
    chargedTo: "A cargo de",
    amount: "Importe",
    receipt: "Ticket",
    actions: "Acciones",
    general: "General",
    management: "Gestión",
    ownerMissing: "Sin propietario asignado",
    notCharged: "El alojamiento ya no se gestiona: no se le cobra a nadie",
    vat: "IVA {pct} %",
    download: "Descargar el ticket",
    edit: "Editar",
    remove: "Eliminar",
  },

  empty: {
    title: "No hay egresos en este periodo",
    text: "Apunta lo que pagas —limpieza, lavandería, reparaciones, software…— y decide si se le repercute al propietario o es un gasto propio de la gestión.",
    create: "Apuntar un egreso",
    filteredTitle: "Ningún egreso coincide con los filtros",
    filteredText: "Prueba con otra búsqueda o quita los filtros para ver todos los egresos del periodo.",
    clear: "Quitar filtros",
  },

  load: {
    error: "No se han podido cargar los egresos.",
    retry: "Reintentar",
  },

  remove: {
    title: "¿Eliminar este egreso?",
    message: "«{concept}» ({amount}) dejará de contar en la analítica y en las liquidaciones.",
    confirm: "Eliminar",
    done: "Egreso eliminado",
    error: "No se ha podido eliminar el egreso. Inténtalo de nuevo.",
  },

  receiptError: "No se ha podido descargar el ticket.",

  drawer: {
    newTitle: "Nuevo egreso",
    editTitle: "Editar egreso",
    newSubtitle: "Lo que pagas por la gestión, a cargo del propietario o de la gestoría.",
    editSubtitle: "Los cambios se reflejan al momento en la analítica y en las liquidaciones.",
    close: "Cerrar",
    sections: {
      expense: "El gasto",
      listing: "Alojamiento y propietario",
      notes: "Notas",
      receipt: "Ticket o factura",
    },
    fields: {
      concept: "Concepto",
      conceptPlaceholder: "Ej.: Limpieza de salida",
      category: "Categoría",
      date: "Fecha",
      supplier: "Proveedor",
      supplierPlaceholder: "Ej.: Lavandería Sol",
      amount: "Importe",
      vat: "IVA",
      vatHint: "Solo informativo: el importe es lo que pagaste, IVA incluido.",
      listing: "Alojamiento",
      listingGeneral: "General de la gestoría (sin alojamiento)",
      unit: "Unidad",
      unitAll: "Todo el alojamiento",
      notesPlaceholder: "Cualquier detalle que quieras recordar",
    },
    charge: {
      label: "Repercutir al propietario",
      general: "Un gasto general es siempre de la gestoría. Elige un alojamiento para cobrárselo a su propietario.",
      loading: "Comprobando el alojamiento…",
      error: "No se ha podido comprobar si este alojamiento se gestiona.",
      retry: "Reintentar",
      notManaged: "Este alojamiento no está marcado como gestionado: el gasto cuenta como propio.",
      notManagedMarked: "El alojamiento ya no se gestiona: no se le cobra a nadie. Desactívalo para dejarlo como gasto propio.",
      own: "Si no lo repercutes, cuenta como gasto propio de la gestión.",
      owner: "Se descontará en la liquidación de {owner}.",
      noOwner: "El alojamiento aún no tiene propietario asignado: se descontará en la liquidación de quien asignes.",
    },
    receipt: {
      drop: "Arrastra aquí la foto o el PDF",
      pick: "o elige un archivo",
      formats: "JPG, PNG, WEBP, HEIC o PDF · máx. 10 MB",
      current: "Ticket guardado",
      download: "Descargar",
      change: "Cambiar",
      remove: "Quitar",
      undo: "Deshacer",
      willRemove: "El ticket se quitará al guardar.",
      willReplace: "sustituirá al guardado",
      tooBig: "El archivo pesa más de 10 MB.",
      badType: "Formato no admitido: sube una foto (JPG, PNG, WEBP o HEIC) o un PDF.",
    },
    errors: {
      required: "Este campo es obligatorio.",
      category: "Elige una categoría.",
      amount: "Pon un importe mayor que 0.",
      vat: "Pon un porcentaje entre 0 y 100.",
      review: "Revisa los campos marcados.",
      generic: "No se ha podido guardar el egreso. Inténtalo de nuevo.",
    },
    discard: {
      title: "¿Descartar los cambios?",
      message: "Lo que has escrito en este egreso se perderá.",
      confirm: "Descartar",
      cancel: "Seguir editando",
    },
    cancel: "Cancelar",
    save: "Guardar egreso",
    saveChanges: "Guardar cambios",
    saving: "Guardando…",
    created: "Egreso guardado",
    updated: "Cambios guardados",
    outOfPeriod: "Guardado. Su fecha ({date}) queda fuera del periodo que estás viendo.",
  },
};
